export default __webpack_public_path__ + "static/media/select-location-bg.73bf4440.png";